import { reduxForm, formValueSelector } from 'redux-form'
import { Input, Loader } from '../../components/common'
import { submitRefundExamFlow } from '../../actions/refundExam'
import { EXAM_SEARCH_FORM_NAME, EXAM_SEARCH_FIELD_NAME } from '../../constants/RefundExamConstants'
import { getExamsSearchedStatus } from '../../selectors/refundExam'

const SelectExamsForRefundForm = ({
  fetchingExams,
  availableExams,
  selectedValues,
  handleSubmit,
}) => {
  if (fetchingExams) return <Loader size="md" />

  return (
    <form onSubmit={handleSubmit}>
      <fieldset>
        {Object.keys(availableExams).map(key => (
          <Input
            type="checkbox"
            key={key}
            name={key}
            label={`${availableExams[key].description}${
              availableExams[key].refunded ? ' (Refunded)' : ''
            }`}
            checked={availableExams[key].refunded || selectedValues[key]}
            disabled={availableExams[key].refunded}
          />
        ))}
      </fieldset>
    </form>
  )
}

const selector = formValueSelector(EXAM_SEARCH_FORM_NAME)

const mapStateToProps = (state, ownProps) => {
  const { exams } = ownProps
  const { fetching: fetchingExams } = getExamsSearchedStatus(state)
  const availableExams = {}
  const initialValues = {}
  const selectedValues = {}
  exams.forEach(exam => {
    availableExams[`${EXAM_SEARCH_FIELD_NAME}_${exam.enrollmentId}`] = exam
    initialValues[`${EXAM_SEARCH_FIELD_NAME}_${exam.enrollmentId}`] = exam.refunded
    selectedValues[`${EXAM_SEARCH_FIELD_NAME}_${exam.enrollmentId}`] = selector(
      state,
      `${EXAM_SEARCH_FIELD_NAME}_${exam.enrollmentId}`
    )
  })
  return {
    fetchingExams,
    availableExams,
    initialValues,
    selectedValues,
  }
}

export default connect(mapStateToProps, { submitRefundExamFlow })(
  reduxForm({
    form: EXAM_SEARCH_FORM_NAME,
    onSubmit: (values, dispatch, props) => {
      const { availableExams } = props
      const examsToRefund = []
      Object.keys(values).forEach(key => {
        // if value is checked AND enrollment has not already been refunded
        if (values[key] && !availableExams[key].refunded) {
          examsToRefund.push(availableExams[key].enrollmentId)
        }
      })
      return props.submitRefundExamFlow(examsToRefund)
    },
  })(SelectExamsForRefundForm)
)
